export const WIN_MESSAGES_ARRAY = [
  [], //0
  [ //1
    "I'm suspicious!?!?!?!" 
  ], 
  [ //2
    'Spectacular!!!', 
    'Awesome!!!', 
    'Fantastic!!!', 
    'Mind Boggling!!!'
  ],
  [ //3
    'Great Job!', 
    'Amazing!', 
    'Impressive!', 
    'Genius!'
  ],
  [ //4
    'Solid Performance',
    'Way to go',
    'Well done',
    'Play more, tell your friends!',
  ], 
  [ //5 
    'Room to spare!?!', 
    'No need to worry!?!', 
    'Solid'
  ], 
  [ //6
    'Phew!!!!',
    'Cutting it close!!!!',
    'Living on the edge!!!!',
    'Flirting with danger!!!!',
    'Had it all the way!?!?!',
  ], 
]
export const GAME_COPIED_MESSAGE = 'Game copied to clipboard'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Not enough letters'
export const WORD_NOT_FOUND_MESSAGE = 'Word(s) not found'
export const HARD_MODE_ALERT_MESSAGE =
  'Hard Mode can only be enabled at the start!'
export const HARD_MODE_DESCRIPTION =
  'Any revealed hints must be used in subsequent guesses'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'For improved color vision'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `The words were ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Must use ${guess} in position ${position}`
export const PRESENT_NOT_CONTAINED_MESSAGE = (letter: string, word: number) =>
  `Guess must contain ${letter} in word ${word}`
export const OTHER_NOT_CONTAINED_MESSAGE = (letter: string, word: number) =>
  `Guess must contain ${letter} in other word`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'Statistics'
export const GUESS_DISTRIBUTION_TEXT = 'Guess Distribution'
export const NEW_WORD_TEXT = 'New words in'
export const SHARE_TEXT = 'Share'
export const TOTAL_TRIES_TEXT = 'Total tries'
export const SUCCESS_RATE_TEXT = 'Success rate'
export const CURRENT_STREAK_TEXT = 'Current streak'
export const BEST_STREAK_TEXT = 'Best streak'
